import Inputmask from "inputmask";

export function form() {
  const inputElements = $('.tel');

  const im = new Inputmask({
    mask: "+38(999)999-99-99",
    'autoUnmask': true
  });

  im.mask(inputElements);

  function setTabsForForm() {
    const formElements = document.querySelectorAll('.form-tabs');
    const ACTIVE_CLASS = 'active';

    if (!formElements.length) {
      return;
    }

    function setTabValue(element, inputElement) {
      const elementValue = element.getAttribute('data-value');

      element.classList.add(ACTIVE_CLASS);
      inputElement.value = elementValue;
    }

    function setFirstTab(fistElement, inputElement) {
      setTabValue(fistElement, inputElement)
    }

    function changeTab(self, inputElement) {
      const currentElement = self;
      const parentElement = currentElement.closest('.tabs');
      const activeElement = parentElement.querySelector(`.tabs__item.${ACTIVE_CLASS}`);

      if (currentElement.classList.contains(`${ACTIVE_CLASS}`) && !activeElement) {
        return;
      }

      activeElement.classList.remove(ACTIVE_CLASS);

      setTabValue(currentElement, inputElement);
    }

    function setHandlerForTabs(tabEl, inputElement) {
      tabEl.addEventListener('click', () => changeTab(tabEl, inputElement));
    }

    formElements.forEach(formContainerEl => {
      const serviceInputForm = formContainerEl.querySelector('input[name="service"]');
      const tabsElements = formContainerEl.querySelectorAll('.tabs__item');

      if (!serviceInputForm || !tabsElements.length) {
        return;
      }

      setFirstTab(tabsElements[0], serviceInputForm);

      tabsElements.forEach(el => setHandlerForTabs(el, serviceInputForm));
    });
  }

  function setCounterForTextarea() {
    const textareaElements = document.querySelectorAll('.input-item--textarea');

    if (!textareaElements.length) {
      return;
    }

    textareaElements.forEach(tabContainerEl => {
      const textAreaElement = tabContainerEl.querySelector('.input-item__textarea');
      const counterElement = tabContainerEl.querySelector('.input-item__counter-value');

      if (!counterElement || !textAreaElement) {
        return;
      }

      textAreaElement.addEventListener('input', function () {
        const textAreaValue = this.value;
        const countValue = textAreaValue.length;

        counterElement.textContent = countValue;
      })
    });
  }

  setCounterForTextarea();
  setTabsForForm();
}


// WEBPACK FOOTER //
// app/scripts/components/form.js